import React from 'react';

export default function SectionTitle({ title }) {
  return (
    <div className="grid -mt-2 py-2 pl-4 sm:pl-0 w-full sticky left-0">
      <h3 className="text-base text-primary font-semibold">{title}</h3>
    </div>
  );
}
